import { render } from "./ShopPayamentHistory.vue?vue&type=template&id=480b2038&scoped=true"
import script from "./ShopPayamentHistory.vue?vue&type=script&lang=js"
export * from "./ShopPayamentHistory.vue?vue&type=script&lang=js"

import "./ShopPayamentHistory.vue?vue&type=style&index=0&id=480b2038&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480b2038"]])

export default __exports__